import Vue from 'vue'
import VueRouter from 'vue-router'


import workstation_h5 from '../views/workstation/index.vue'
import quotation_1 from '../views/quotation_3/index.vue'
import evaluation_h5 from '../views/evaluation/index.vue'
import quotation_2 from '../views/quotation_1/index.vue'
import quotation_3 from '../views/quotation_2/index.vue'
import e26_h5 from '../views/e26/index.vue'
import about_us from '../views/about_us/index.vue'
import solution_h5 from '../views/solution/index.vue'
import re_ass from '../views/re_ass/index.vue'
import home from '../views/home/index.vue'

import lanhu_shouyegaiban from '../views/lanhu_shouyegaiban/index.vue'
import lanhu_chanpinjieshaochufanggongzuozhan from '../views/lanhu_chanpinjieshaochufanggongzuozhan/index.vue'

import lanhu_guanyuwomen from '../views/lanhu_guanyuwomen/index.vue'

import lanhu_chanpinjieshaochufanggongzuozhan_1 from '../views/lanhu_chanpinjieshaochufanggongzuozhan_1/index.vue'

import lanhu_chanpinjieshaotishinengji from '../views/lanhu_chanpinjieshaotishinengji/index.vue'
import lanhu_gongnengjibaojiaxiugaiban from '../views/lanhu_gongnengjibaojiaxiugaiban/index.vue'
import lanhu_gongnengjibaojia from '../views/lanhu_gongnengjibaojia/index.vue'
import lanhu_jiejuefangan from '../views/lanhu_jiejuefangan/index.vue'
import lanhu_kangfuzhushou from '../views/lanhu_kangfuzhushou/index.vue'

import lanhu_shouyechanpinjieshao from '../views/lanhu_shouyechanpinjieshao/index.vue'
import lanhu_guanyuwomenxiugaiban from '../views/lanhu_guanyuwomenxiugaiban/index.vue'
import lanhu_chanpinjieshaoe26 from '../views/lanhu_chanpinjieshaoe26/index.vue'
import lanhu_chanpinjieshaoe26_1 from '../views/lanhu_chanpinjieshaoe26_1/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/homepage"
  },
  {
    path: '/homepage',
    name: 'lanhu_shouyegaiban',
    component: lanhu_shouyegaiban
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/workstation2',
    name: 'lanhu_chanpinjieshaochufanggongzuozhan',
    component: lanhu_chanpinjieshaochufanggongzuozhan
  },
  {
    path: '/lanhu_guanyuwomen',
    name: 'lanhu_guanyuwomen',
    component: lanhu_guanyuwomen
  },
  {
    path: '/workstation',
    name: 'lanhu_chanpinjieshaochufanggongzuozhan_1',
    component: lanhu_chanpinjieshaochufanggongzuozhan_1
  },
  {
    path: '/workstation_h5',
    name: 'workstation_h5',
    component: workstation_h5
  },
  {
    path: '/evaluation',
    name: 'lanhu_chanpinjieshaotishinengji',
    component: lanhu_chanpinjieshaotishinengji
  },
  {
    path: '/evaluation_h5',
    name: 'evaluation_h5',
    component: evaluation_h5
  },
  {
    path: '/quotation',
    name: 'lanhu_gongnengjibaojiaxiugaiban',
    component: lanhu_gongnengjibaojiaxiugaiban
  },
  {
    path: '/quotation_1',
    name: 'quotation_1',
    component: quotation_1
  },
  {
    path: '/quotation_2',
    name: 'quotation_2',
    component: quotation_2
  },
  {
    path: '/quotation_3',
    name: 'quotation_3',
    component: quotation_3
  },
  {
    path: '/lanhu_gongnengjibaojia',
    name: 'lanhu_gongnengjibaojia',
    component: lanhu_gongnengjibaojia
  },
  {
    path: '/solution',
    name: 'lanhu_jiejuefangan',
    component: lanhu_jiejuefangan
  },
  {
    path: '/solution_h5',
    name: 'solution_h5',
    component: solution_h5
  },
  {
    path: '/re_as',
    name: 'lanhu_kangfuzhushou',
    component: lanhu_kangfuzhushou
  },
  {
    path: '/re_ass',
    name: 're_ass',
    component: re_ass
  },

  {
    path: '/lanhu_shouyechanpinjieshao',
    name: 'lanhu_shouyechanpinjieshao',
    component: lanhu_shouyechanpinjieshao
  },
  {
    path: '/about',
    name: 'lanhu_guanyuwomenxiugaiban',
    component: lanhu_guanyuwomenxiugaiban
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: about_us
  },
  {
    path: '/lanhu_chanpinjieshaoe26',
    name: 'lanhu_chanpinjieshaoe26',
    component: lanhu_chanpinjieshaoe26
  },
  {
    path: '/e26',
    name: 'lanhu_chanpinjieshaoe26_1',
    component: lanhu_chanpinjieshaoe26_1
  },
  {
    path: '/e26_h5',
    name: 'e26_h5',
    component: e26_h5
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
